import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions } from "@angular/http";
import { ElectionProgSchedule } from "../models/electionProgSchedule";
import { environment } from "../../../../environments/environment";
import { LocalBodyAllotTOElectionProg } from "../models/localBodyAllotToElectionProg";
import { SectionCount } from "../models/sectionCount";
import { UpdateNomByOfficer } from "../../../models/updateNomByOfficer";
import { parse } from "querystring";

@Injectable()
export class ElectionprogramService {
  downloadlocalBodyTypeBasedOnEpIdnDistId(localbodyId: any) {
    throw new Error('Method not implemented.');
  }
  headers: Headers;
  headers1:Headers;
  options: RequestOptions;
  options1:RequestOptions;
  storageEl: any;
  storageEl1: any;
  sectionData: SectionCount[] = new Array<SectionCount>();
  officerNomData: UpdateNomByOfficer[] = new Array<UpdateNomByOfficer>();
  mapDataLat: any;
  mapDataLong: any;
  BaseUrl = "https://webapi.truevoter.in/api";
  BaseUrl2 = environment.config.baseUrlDhananjoy;
  BaseUrl1 = environment.config.baseUrlNomDhananjoy;
  token = localStorage.getItem('bearerToken');

  constructor(private _http: Http) {
    this.headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
    });
    this.options = new RequestOptions({ headers: this.headers });

      this.headers1= new Headers({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('bearerToken'),
        
      });

      this.options1 = new RequestOptions({ headers: this.headers1 });
  }

  downloadElectionProgramDays() {
    return this._http
      .get(this.BaseUrl + "/ElectionProgram/downloadnoofdaysEP")
      .map((res) => res.json());
  }

  saveElectionProgSchedule(electionPrgData: ElectionProgSchedule) {
    
    return this._http
      .post(
        this.BaseUrl + "/ElectionProgram/addElectionProgram",
        electionPrgData
      )
      .map((res) => res.json());
  }

  downloadHolidayList() {
    return this._http
      .get(this.BaseUrl + "/ElectionProgram/getholidaylist")
      .map((res) => res.json());
  }

  downloadElectionProgBasicDetails(stateId: number) {
    return this._http
      .get(this.BaseUrl + "/DailyExpense/getelectionprogram?stateId=" + stateId)
      .map((res) => res.json());
  }
  downloadsmsTemplate(sms: string) {
    return this._http
      .get(this.BaseUrl + "/downloadsmsTemplate=" + sms)
      .map((res) => res.json());
  }

  downloadElectionProgSchedule(epId: number) {
    return this._http
      .get(this.BaseUrl + "/ElectionProgram/getelectionprogramscheduledate?id=" + epId)
      .map((res) => res.json());
  }

  downloadLocalBody(distId: number) {
    return this._http
      .get(this.BaseUrl + "/ElectionProgram/getlocalbodyforEP?districtId=" + distId)
      .map((res) => res.json());
  }

  allotLocalBodyToElectionProg(localBodyData: LocalBodyAllotTOElectionProg) {
    return this._http
      .post(
        this.BaseUrl + "/ElectionProgram/addlocalbodytoEPNew",
        localBodyData
      )
      .map((res) => res.json());
  }

  downloadElectionProgAndDates(stateId: number) {
    return this._http
      .get(
        this.BaseUrl + "/ElectionProgram/downloadElectionProgramWithDates?stateId=" + stateId
      )
      .map((res) => res.json());
  }

  
  downloadElectionProgById(epId: number) {
    return this._http
      .get(
        this.BaseUrl + "/Support/searchElectionProgramDetailsbyepId?epId=" + epId
      )
      .map((res) => res.json());
  }

  downloadLocalBodyById(localBodyId:number){
    return this._http
      .get(this.BaseUrl + "/Support/searchLbDetailsByLbId?localBodyId=" + localBodyId)
      .map((res) => res.json());
  }
  
  downloadCandidateDetailsBasedOnNomID(nomId: string) {
    return this._http
   .get(this.BaseUrl + "/Nomination/getcandidateDetailsBasedOnNominationID?nominationId=" + nomId)
   .map((res) => res.json());
   
}
downloadlocalBodyTypeBasedOnEpIdnDistIdfun(epId: string,distId: string) {
  return this._http
 .get(this.BaseUrl + "/LocalBody/downloadlocalBodyTypeBasedOnEpIdnDistId?epId=" +epId+'&distId='+distId)
 .map((res) => res.json());
 
}

 

  downloadLocalBodiesByEPId(stateId: number, epId: number) {
    return this._http
      .get(
        this.BaseUrl +
          "/ElectionProgram/downloadLocalbodyAddedToEP1?stateId=" +
          stateId +
          "&&epId=" +
          epId
      )
      .map((res) => res.json());
  }

  updateElectionProgramAndLocalBodySchedule(
    electionProgData: LocalBodyAllotTOElectionProg
  ) {
    return this._http
      .post(
        this.BaseUrl + "/ElectionProgram/updateElectionProgramAndLB",
        electionProgData
      )
      .map((res) => res.json());
  }
  getSectionRecords(acNo) {
    return this._http
      .get(
        "http://www.truevoters.in/pdfservice/Service1.svc/DownloadVoterListACNOwis?acno=" +
          acNo
      )
      .map((res) => res.json()["DownloadVoterListACNOwisResult"]);
  }
   
  saveSectionCount(section: SectionCount[]) {
    
    return this._http
      .post(
        this.BaseUrl + "/SectionCount/sectionCount",
        section
      )
      .map((res) => res.json());
  }
  
  downloadTotOfficersGridDataSprt(
    
    epId: number,
    districtId: number,
    localBodyId: number,
   
  ) {
    return this._http
    
      .get(
        this.BaseUrl + 
         "/SupportDbDetails/downloadTotOfficersGridDataSprt?epId=" +
          epId +
          "&localBodyId=" +
          localBodyId +
           "&distId=" +
          districtId 
         
      )
      .map((res) => res.json());
  }

  downloadCredentials(userMobileNo: string) {
    return this._http
      .get(
        this.BaseUrl + "/Registration/downloadPasswardAndOtp?userMobileNo=" + userMobileNo
      )
      .map((res) => res.json());
  }

  downloaduserTypeAndroleIdByMobNo(userMobileNo: string){
    return this._http
      .get(
        this.BaseUrl + "/Support/downloaduserTypeAndroleIdByMobNo?userMobileNo=" + userMobileNo
      )
      .map((res) => res.json());
  }

  downloadMobileNoByNomId(nomId: string) {
    return this._http
      .get(this.BaseUrl + "/Nomination/searchMobNoByNomId?nominationId=" + nomId)
      .map((res) => res.json());
  }

  downloadNominationDetailByNomID(nomId: string) {
    return this._http
      .get(this.BaseUrl + "/Nomination/getNominationDetailsByNomId?nominationId=" + nomId)
      .map((res) => res.json());
  }
 


  addNomDetailByOfficer(addDetail: UpdateNomByOfficer) {
    this.officerNomData[0] = addDetail;
    console.log(this.officerNomData);
    return this._http
      .post(
        this.BaseUrl + "/Nomination/addOfficerNomUpdate",
       this.officerNomData
      )
      .map((res) => res.json());
  }

  addWardDetailByOfficer(addDetail: UpdateNomByOfficer){
    this.officerNomData[0] = addDetail;
    return this._http
      .post(
        this.BaseUrl + "/Nomination/addOfficerWardUpdateNom",
      this.officerNomData
      )
      .map((res) => res.json());
  }

  serchBoothLocation(
    epId: any,
    localBodyType: any,
    localBodyId: any,
    distId: any
  ) {
    return this._http
      .get(
        this.BaseUrl +
          "/LocateBooth/downloadLocateBoothsearch?epId=" +
          epId +
          "&localBodyType=" +
          localBodyType +
          "&localBodyId=" +
          localBodyId +
          "&distId=" +
          distId
      )
      .map((res) => res.json());
  }

  newVoterLogin() {
    const object = {
      Username: "uGUGIiBaLQNf2hZ1WhajIk5PBTbcPahFSvjC+YEq4Ws=",
      Password: "s6u3Fe2fB6kygM50/h9xBA==",
    };
    return this._http
      .post("https://webapi.truevoter.in/api/Registration/loginnew", object, this.options)
      .map((res) => res.json());
  }

  getNewLocalBodyName(District, AC_NO) {
    console.log(this.token);
    console.log(this.options1);
    return this._http
      .get(
          "https://voterlist.truevoter.in/Value/DownloadSearchLocalBodyNameDetailsNew?District=" +
          District +
          "&LocalBody=1" +
          "&AC_NO=" +
          AC_NO
      )
      .map((res) => res.text());
  }

  downloadVoterCountData(state: number, distId: number,talukaId:number) {
    return this._http
      .get(
       'https://api.truevoter.in/TrueVoter_Pooling/downloadpoolingReportStateDistrictAndTaluka?state='+state+'&distId='+distId+'&talukaId='+talukaId
      )
      .map((res) => res.json());
  }

  downloadNominationDashboardCount(epId: number) {
    return this._http
      .get(this.BaseUrl + "/RoDashBoard/roDashBoardDownloadDistGpDetails?epId=" + epId)
      .map((res) => res.json());
  }

  downloadNominationDashboardCount2(epId: number) {
    return this._http
      .get(this.BaseUrl + "/RoDashBoard/roDashBoardLocalBodyIdReviewNew?epId=" + epId)
      .map((res) => res.json());
  }

  downloadTalukaIdReview(talukaId:number){
    return this._http
      .get(this.BaseUrl + "/RoDashboard/collectorCntNewByTalukaId?talukaId="+ talukaId)
      .map((res) => res.json());
  }

  downloadDbcount() {
    return this._http.get(this.BaseUrl + '/SupportDbDetails/downloadtotalDbCounts')
            .map(res => res.json());
  }
  downloadpendingOtpService() {
    return this._http
      .get(this.BaseUrl + '/Registration/downloadpendingOtpService1')
      .map((res) => res.json());
  }
  pendingOtpServiceByMobNo(mobileNo: string) {
    return this._http
      .get(this.BaseUrl + '/Registration/pendingOtpServiceByMobNo1?userMobileNo=' + parseInt(mobileNo))
      .map((res) => res.json());
  }
  
  pendingOtpForVoterObjDetails() {
    
    return this._http
      .get(this.BaseUrl + "/VoterListObjection/pendingOtpForVoterObjDetails1")
      .map((res) => res.json());
  }
  
  pendingOtpForVoterObjByMobNo(mobileNo: string) {
    
    return this._http
      .get(this.BaseUrl + "/VoterListObjection/pendingOtpForVoterObjByMobNo?mobileNo=" + parseInt(mobileNo))
      .map((res) => res.json());
  }


 downloadElectionProgramWithDates(state: number) {
    return this._http
      .get(this.BaseUrl + "/ElectionProgram/downloadElectionProgramWithDates?stateId=")
      .map((res) => res.json());
  }

  activeDeactiveElectionProgram(electionProgListData: ElectionProgSchedule) {
    let req = [{
      id: electionProgListData.id,
      isActive: electionProgListData.isActive
    }]
    return this._http
      .post(
        this.BaseUrl + "/ElectionProgram/activeDeactiveElectionProgram",
       req
      )
      .map((res) => res.json());
  }
 }





// WEBPACK FOOTER //
// ./src/app/user-view/superAdmin/services/electionprogram.service.ts